import { makeStyles } from '@mui/styles'
const useStylesEditUserOfOrganization = makeStyles(() => ({
  mainBox: {
    width: '100%',
    height: '95vh'
  },
  containBox: {
    maxHeight: '90%',
    width: '100%',
    overflow: 'scroll',
    overflowX: 'hidden'
  },
  editUserTypography: {
    mb: 1,
    mt: 2,
    fontWeight: 'bold',
    color: '#32332E',
    fontSize: 18,
    marginTop: '5%'
  },
  instructionsTypography: {
    mt: 1,
    mb: 2,
    ml: 1,
    color: '#2F3D40',
    marginTop: '2%',
    marginBottom: '2%'
  },
  fieldsTypography: {
    fontSize: 14,
    mt: 1,
    mb: 1,
    ml: 1,
    marginLeft: '1.5%',
    marginBottom: '2%',
    marginTop: '2%'
  },
  inputFields: {
    width: '70%',
    marginLeft: '1.5%'
  },
  boxButton: {
    width: '100%',
    height: '10%',
    position: 'absolute',
    bottom: 0,
    right: 0,
    display: ' flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  butons: {
    width: 90,
    height: 35,
    marginLeft: '5%',
    backgroundColor: '#1C846F',
    boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    WebkitBoxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    MozBoxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    borderRadius: 1,
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex'
  },
  editTypography: {
    color: '#FFFFFF',
    cursor: 'pointer',
    fontSize: 16
  },
  cancelButton: {
    width: '95%',
    marginLeft: '5%',
    bottom: 20,
    display: 'flex'
  },
  cancelButtonStyle: {
    width: 90,
    height: 35,
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    WebkitBoxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    MozBoxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    borderRadius: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  cancelButtonTypography: {
    color: '#262626',
    cursor: 'pointer',
    fontSize: 16,
    '&:hover': {
      color: '#1BF57F'
    }
  }
}))
export default useStylesEditUserOfOrganization
